import { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const UnderConstructionDams = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: underConstructionDams = [], isLoading: pipelineDataIsLoading } =
    useGetProtectedApiDataQuery({
      url: "project_under_construction",
      lang: languageType,
    });

  const categoryWiseData = (arr, category) => {
    return arr.filter((item) => item.field_select_for === category);
  };

  const hydroType = categoryWiseData(underConstructionDams, "Hydro");
  const solarType = categoryWiseData(underConstructionDams, "Solar");

  useTableResponsive(underConstructionDams);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(underConstructionDams);
  }, [underConstructionDams]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (pipelineDataIsLoading) {
    return <Loader />;
  }

  const renderProjectTable = (projects, title) => {
    if (projects.length === 0) return null;

    return (
      <>
        <div className="title-sec">
          <h2 className="mt-2">{title}</h2>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="table-responsive">
              <table className="table table-striped custom-table">
                <thead className="thead-dark">
                  <tr>
                    <th className="no-wrap-td">
                      {getText("S.No.", "क्र. सं.")}
                    </th>
                    <th>{getText("Name of the Project", "परियोजना का नाम")}</th>
                    <th>{getText("State", "राज्य")}</th>
                    <th>{getText("Status", "स्थिति")}</th>
                    <th className="no-wrap-td">
                      {getText("Commissioning Schedule", "आयोग शेड्यूल")}
                      <br />
                      {getText(
                        "(tent. from Investment Approval)",
                        "(निवेश स्वीकृति से अनुमानित)",
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((item, index) => (
                    <tr key={index}>
                      <td data-key={getText("S.No.", "क्र. सं.")}>
                        {index + 1}
                      </td>
                      <td
                        data-key={getText(
                          "Name of the Project",
                          "परियोजना का नाम",
                        )}
                      >
                        {item.title}
                      </td>
                      <td data-key={getText("State", "राज्य")}>
                        {item.field_state}
                      </td>
                      <td data-key={getText("Status", "स्थिति")}>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.body }}
                        ></div>
                      </td>
                      <td
                        className="no-wrap-td"
                        data-key={getText(
                          "Commissioning schedule (tent. from investment approval)",
                          "कमीशनिंग शेड्यूल",
                        )}
                      >
                        {item.field_commissioning_schedule_ten}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        titleTwo={innerBannerTitle}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          {renderProjectTable(hydroType, getText("Hydro", "जलविद्युत"))}

          {renderProjectTable(solarType, getText("Solar", "सोलर"))}
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        </div>
      </div>
    </>
  );
};

export default UnderConstructionDams;
